<template>
  <div>
    <breadcrumb :items="breadcrumbs"></breadcrumb>
    <div @click="goToNextFarm()" class="float-right mt-n10 mr-5 primary--text subtitle-2">Next Farm ></div>
    <v-container fluid>
      <farm-info
        :key="$route.params.farmId"
        :id="$route.params.farmId"
        :active="isActive"
        :getStatus="getItem"
      />
      <div class="mt-2">
        <!---------------------- Tablet screen ------------------------------>
        <!-- start -->
        <v-card
          class="px-4"
          :class="loading ? '' : 'py-1'"
          v-if="checkBreakPoints"
          elevation="0"
          :loading="loading"
        >
          <div class="d-flex mt-5">
            <v-text-field
              prepend-inner-icon="mdi-magnify"
              outlined
              height="5px"
              :placeholder="$t('search')"
              dense
              v-model="search"
              @click:append="searchUsers"
              @input="resetSearchOnEmpty"
              class="shrink"
            ></v-text-field>
            <v-btn
              :disabled="search.length < 1"
              color="primary"
              height="40"
              width="40"
              max-width="40"
              outlined
              class="ml-8"
              @click="searchUsers"
            >
              <v-icon>mdi-filter-outline</v-icon>
            </v-btn>
            <v-spacer></v-spacer>
            <div class="py-1 title">
              {{ from }} - {{ to }} {{$t('of')}} {{ totalproducts }}
            </div>
            <v-btn
              class="mx-2"
              fab
              small
              outlined
              color="primary"
              :disabled="tabletTableOptions.page <= 1"
              @click="tabletPageChange(false)"
            >
              <v-icon dark> mdi-chevron-left </v-icon>
            </v-btn>
            <v-btn
              class="mx-2"
              fab
              small
              outlined
              color="primary"
              :disabled="tabletTableOptions.page >= totalPages"
              @click="tabletPageChange(true)"
            >
              <v-icon dark> mdi-chevron-right </v-icon>
            </v-btn>
          </div>
          <v-card
            class="inner-card my-4 py-4 px-4"
            v-for="(item, index) in items"
            elevation="0"
            :key="item.productNumber"
            :style="
              index % 2 !== 0 && { backgroundColor: 'rgba(243, 243, 243, 0.5)' }
            "
            @mouseover="selectItem(item)"
            @mouseleave="unSelectItem()"
            @click="
              $router.push({
                name: 'SingleProduct',
                params: {
                  farmId: item.farmNumber,
                  productId: item.productNumber,
                },
              })
            "
          >
            <v-row class="py-4 px-4" no-gutters>
              <v-col md="6">{{$t('farm.productName')}}</v-col>
              <v-col md="6">{{ item.name }}</v-col>
            </v-row>
            <v-row class="py-4 px-4" no-gutters>
              <v-col md="6">{{$t('farm.inStock')}}</v-col>
              <v-col md="6">{{ item.stockQty }} {{ item.stockUom }}</v-col>
            </v-row>
            <v-row class="py-4 px-4" no-gutters>
              <v-col md="6">{{$t('farm.stockStatus')}}</v-col>
              <v-col md="6">
                <v-btn
                  v-if="item.stockStatus == 'IN STOCK'"
                  x-small
                  rounded
                  min-width="120"
                  color="green2"
                  depressed
                  class="primary--text"
                  height="34"
                  style="border: 1px solid green !important"
                >
                  {{ item.stockStatus }}
                </v-btn>
                <v-btn
                  v-else-if="item.stockStatus == 'CRITICALLY LOW'"
                  x-small
                  rounded
                  min-width="120"
                  color="#ffd7b5"
                  depressed
                  class="orange--text"
                  style="border: 1px orange solid"
                  height="34"
                >
                  {{ item.stockStatus }}
                </v-btn>
                <v-btn
                  v-else-if="item.stockStatus == 'LOW STOCK'"
                  x-small
                  rounded
                  min-width="120"
                  color="#e3e3e3"
                  depressed
                  class="black--text"
                  height="34"
                  style="border: 1px black solid"
                >
                  {{ item.stockStatus }}
                </v-btn>
                <v-btn
                  v-else-if="item.stockStatus == 'OUT OF STOCK'"
                  x-small
                  rounded
                  min-width="120"
                  color="#ffd6dc"
                  depressed
                  class="pink--text"
                  height="34"
                  style="border: 1px solid #FF1493 !important"
                >
                  {{ item[h.value] }}
                </v-btn>
                <v-btn
                  v-else
                  x-small
                  rounded
                  min-width="120"
                  color="grey"
                  depressed
                  class="black--text"
                  height="34"
                >
                  {{ item.stockStatus }}
                </v-btn>
              </v-col>
            </v-row>
          </v-card>
        </v-card>
        <!------------------- end ------------------------------>
        <v-card v-else elevation="0" class="px-5">
          <v-card-text>
            <template>
              <div class="d-flex mt-5">
                <v-text-field
                  prepend-inner-icon="mdi-magnify"
                  outlined
                  height="5px"
                  :placeholder="$t('farm.searchByProductName')"
                  dense
                  v-model="search"
                  @click:append="searchUsers"
                  @input="resetSearchOnEmpty"
                  class="shrink"
                ></v-text-field>
                <v-btn
                  :disabled="search.length < 1"
                  color="primary"
                  height="40"
                  width="40"
                  max-width="40"
                  outlined
                  class="ml-8"
                  @click="searchUsers"
                >
                  <v-icon>mdi-filter-outline</v-icon>
                </v-btn>
                <v-spacer></v-spacer>
                <div class="py-1 title">
                  {{ from }} - {{ to }} {{$t('of')}} {{ totalproducts }}
                </div>
                <v-btn
                  class="mx-2"
                  fab
                  small
                  outlined
                  color="primary"
                  :disabled="tableOptions.page <= 1"
                  @click="pageChange(false)"
                >
                  <v-icon dark> mdi-chevron-left </v-icon>
                </v-btn>
                <v-btn
                  class="mx-2"
                  fab
                  small
                  outlined
                  color="primary"
                  :disabled="tableOptions.page >= totalPages"
                  @click="pageChange(true)"
                >
                  <v-icon dark> mdi-chevron-right </v-icon>
                </v-btn>
                <v-menu
                  v-model="menu"
                  :close-on-content-click="false"
                  :nudge-width="200"
                  left
                  :min-width="417"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      class="mx-2"
                      fab
                      small
                      outlined
                      color="primary"
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon dark> mdi-cog-outline </v-icon>
                    </v-btn>
                  </template>

                  <v-card width="417">
                    <v-list>
                      <v-list-item>
                        <v-list-item-content>
                          <v-list-item-title>{{
                            $t("customization")
                          }}</v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                      <v-divider></v-divider>
                      <div class="pl-3 pt-2 font-weight-normal">
                        {{ $t("recordsPerPage") }}
                      </div>
                      <v-list-item>
                        <v-list-item-content>
                          <v-slider
                            v-model="itemsPerPageSlider"
                            :tick-labels="itemsPerPageOptions"
                            :max="3"
                            step="1"
                            ticks="always"
                            tick-size="4"
                          ></v-slider>
                        </v-list-item-content>
                      </v-list-item>
                      <v-divider class="mt-n3"></v-divider>
                    </v-list>
                    <v-card-text>
                      <v-container fluid>
                        <v-row>
                          <v-col
                            class="mt-n9"
                            cols="6"
                            v-for="header in headers"
                            :key="header.value"
                          >
                            <v-checkbox
                              v-model="selectedHeaders"
                              :label="header.text"
                              color="primary"
                              :value="header.text"
                              hide-details
                            ></v-checkbox>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-card-text>
                    <v-layout justify-center>
                      <v-card-actions class="mb-5">
                        <v-spacer></v-spacer>

                        <v-btn
                          outlined
                          color="primary"
                          @click="menu = false"
                          width="190"
                        >
                          {{ $t("restoreDefault") }}
                        </v-btn>
                        <v-btn
                          color="primary"
                          width="190"
                          @click="resetTableStructure"
                        >
                          {{ $t("apply") }}
                        </v-btn>
                      </v-card-actions>
                    </v-layout>
                  </v-card>
                </v-menu>
                <v-btn
                  class="mx-2"
                  fab
                  small
                  outlined
                  color="primary"
                  @click="exportToPDF"
                >
                  <!-- <v-icon dark> mdi-export </v-icon> -->
                  <v-img src="/icons/download.svg"></v-img>
                </v-btn>
                <v-btn
                  class="mx-2"
                  fab
                  small
                  outlined
                  color="primary"
                  @click="printPDF"
                >
                  <v-icon dark> mdi-printer </v-icon>
                </v-btn>
                <!-- <v-btn
                                class="mx-2"
                                fab
                                small
                                outlined
                                color="primary"
                                disabled
                            >
                                <v-icon dark>
                                    mdi-cog-outline
                                </v-icon>
                            </v-btn> -->
              </div>
            </template>
            <div ref="document">
              <v-data-table
                :headers="tableHeaders"
                :items="items"
                v-model="selected"
                show-select
                :items-per-page="10"
                :loading="loading"
                :loading-text="$t('farm.loadingProductsPleaseWait')"
                :hide-default-footer="true"
                :footer-props="{
                  'items-per-page-options': [5, 10, 25],
                  'show-first-last-page': true,
                  'show-current-page': true,
                  'items-per-page-text': 'Products per page',
                }"
                :options.sync="tableOptions"
                :server-items-length="totalproducts"
              >
                <template v-slot:progress>
                  <v-progress-linear
                    color="primary"
                    :height="8"
                    indeterminate
                  ></v-progress-linear>
                </template>
                <template v-if="items.length > 0" v-slot:body="{ items }">
                  <tbody>
                    <tr
                      v-for="item in items"
                      :key="item.productNumber"
                      @mouseover="selectItem(item)"
                      @mouseleave="unSelectItem()"
                      style="position: relative; width: 0; height: 0"
                      @click="
                        $router.push({
                          name: 'SingleProduct',
                          params: {
                            farmId: item.farmNumber,
                            productId: item.productNumber,
                          },
                        })
                      "
                    >
                      <td>
                        <v-checkbox
                          multiple
                          v-model="selected"
                          :value="item"
                          style="margin: 0px; padding: 0px"
                          hide-details
                          v-on:click.stop=""
                        />
                      </td>
                      <template v-for="h in tableHeaders">
                        <td
                          :key="h.value"
                          class="text-center"
                          v-if="h.value == 'stockStatus'"
                        >
                          <v-btn
                            v-if="item.stockStatus == 'IN STOCK'"
                            x-small
                            rounded
                            min-width="120"
                            color="green2"
                            depressed
                            class="primary--text"
                            height="34"
                            style="border: 1px solid green !important"
                          >
                            {{ item[h.value] }}
                          </v-btn>
                          <v-btn
                            v-else-if="item.stockStatus == 'CRITICALLY LOW'"
                            x-small
                            rounded
                            min-width="120"
                            color="#ffd7b5"
                            depressed
                            class="orange--text"
                            style="border: 1px solid orange !important"
                            height="34"
                          >
                            {{ item[h.value] }}
                          </v-btn>
                          <v-btn
                            v-else-if="item.stockStatus == 'LOW STOCK'"
                            x-small
                            rounded
                            min-width="120"
                            color="#e3e3e3"
                            depressed
                            class="black--text"
                            height="34"
                            style="border: 1px solid black !important"
                          >
                            {{ item[h.value] }}
                          </v-btn>
                          <v-btn
                            v-else-if="item.stockStatus == 'OUT OF STOCK'"
                            x-small
                            rounded
                            min-width="120"
                            color="#ffd6dc"
                            depressed
                            class="pink--text"
                            height="34"
                            style="border: 1px solid #FF1493 !important"
                          >
                            {{ item[h.value] }}
                          </v-btn>
                          <v-btn
                            v-else
                            x-small
                            rounded
                            min-width="120"
                            color="grey"
                            depressed
                            class="black--text"
                            height="34"
                            style="border: 1px solid #1e1e1e !important"
                          >
                            {{ item[h.value] }}
                          </v-btn>
                        </td>
                        <td
                          :key="h.value"
                          class="text-center"
                          v-else-if="
                            h.value == 'stockQty' || h.value == 'stockUom'
                          "
                        >
                          {{ item.stockQty }} {{ item.stockUom }}
                        </td>
                        <td
                          :key="h.value"
                          class="text-center"
                          v-else-if="h.value == 'name'"
                        >
                          {{ item[h.value] }}
                        </td>
                        <td :key="h.value" class="text-center" v-else>
                          {{ item[h.value] }}
                        </td>
                      </template>
                      <!-- <td class="text-center">{{ item.name }}</td>
                      <td class="text-center">
                        {{ item.productCategory.name }}
                      </td>
                      <td class="text-center">
                        {{ item.stockQty }} {{ item.stockUom }}
                      </td>
                      <td class="text-center">
                        <v-btn
                          v-if="item.stockStatus == 'IN STOCK'"
                          x-small
                          rounded
                          min-width="120"
                          color="green2"
                          depressed
                          class="primary--text"
                          height="34"
                          style="border: 1px solid green !important"
                        >
                          {{ item.stockStatus }}
                        </v-btn>
                        <v-btn
                          v-else-if="item.stockStatus == 'CRITICALLY LOW'"
                          x-small
                          rounded
                          min-width="120"
                          color="red2"
                          depressed
                          class="red--text"
                          style="border: 1px solid red !important"
                          height="34"
                        >
                          {{ item.stockStatus }}
                        </v-btn>
                        <v-btn
                          v-else-if="item.stockStatus == 'LOW STOCK'"
                          x-small
                          rounded
                          min-width="120"
                          color="#ffd7b5"
                          depressed
                          class="orange--text"
                          height="34"
                          style="border: 1px solid orange !important"
                        >
                          {{ item.stockStatus }}
                        </v-btn>
                        <v-btn
                          v-else
                          x-small
                          rounded
                          min-width="120"
                          color="grey"
                          depressed
                          class="black--text"
                          height="34"
                          style="border: 1px solid #1e1e1e !important"
                        >
                          {{ item.stockStatus }}
                        </v-btn>
                      </td> -->
                      <!-- <td
                          style="position: absolute; right: 10px; top: 4px"
                          v-if="item === selectedItem"
                        >
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                x-small
                                fab
                                v-bind="attrs"
                                v-on="on"
                                :to="{
                                  name: 'SingleProduct',
                                  params: {
                                    farmId: item.farmNumber,
                                    productId: item.productNumber,
                                  },
                                }"
                              >
                                <v-icon>mdi-dots-horizontal</v-icon></v-btn
                              >
                            </template>
                            <span>More Details</span>
                          </v-tooltip>
                        </td> -->
                    </tr>
                  </tbody>
                </template>
              </v-data-table>
            </div>
          </v-card-text>
        </v-card>
      </div>
      <!-- <div class="float-right mt-5 mb-5">
        <v-btn
          width="146"
          class="mr-2"
          outlined
          color="primary"
          @click="generateReport()"
          >Export as PDF</v-btn
        >
        <v-btn width="146" type="submit" color="primary">Print</v-btn>
      </div> -->
    </v-container>
  </div>
</template>

<script>
import Breadcrumb from "@/components/core/Breadcrumb";
import NtrService from "@/_services/NtrService";
import loadingMixin from "@/mixins/LoadingMixin";
import FarmInfo from "./FarmInfo.vue";
import html2pdf from "html2pdf.js";
import printJS from "print-js";
export default {
  components: {
    breadcrumb: Breadcrumb,
    FarmInfo,
  },
  // async created() {
  //   if (this.checkBreakPoints)await  this.getTabletItem();
  // },
  computed: {
    checkBreakPoints() {
      if (this.$vuetify.breakpoint.width <= 980) return true;
      return false;
    },
  },
  async mounted() {
    this.tableHeaders = this.headers;
    this.selectedHeaders = this.allSelectedHeaders;
    if (this.checkBreakPoints) await this.getTabletItem();
    else await this.getItem();
    this.farms = localStorage.getItem("farms");
    this.farms = this.farms.split(',')
  },
  data() {
    return {
      from: 0,
      to: 0,
      totalPages: 1,
      showingRows: 0,
      currentrows: 0,
      search: "",
      selected: [],
      items: [],
      totalproducts: 0,
      selectedItem: false,
      itemsPerPageSlider: 1,
      itemsPerPageOptions: [5, 10, 25, 50],
      selectedHeaders: [],
      tableHeaders: [],
      menu: false,
      isActive: true,
      loading: false,
      length: 0,
      pageCount: 0,
      tableOptions: {},
      tabletTableOptions: { itemsPerPage: 5, page: 1, sortBy: [] },
      oldSelected: [],
      farms: [],
      farmCounter: 0,
      allSelectedHeaders: [
        this.$t('farm.productName'),
        this.$t('farm.productCategory'),
        this.$t('farm.inStock'),
        this.$t('farm.stockStatus'),
      ],
      noRecordHeader: [
        this.$t('farm.productName'),
        this.$t('farm.productCategory'),
        this.$t('farm.inStock'),
        this.$t('farm.stockStatus'),
      ],
      headers: [
        {
          text: this.$t('farm.productName'),
          align: "center",
          value: "name",
        },
        {
          text: this.$t('farm.productCategory'),
          value: "productCategory.name",
          sortable: false,
          align: "center",
        },
        {
          text: this.$t('farm.inStock'),
          value: "stockQty",
          align: "center",
        },
        {
          text: this.$t('farm.stockStatus'),
          value: "stockStatus",
          sortable: false,
          align: "center",
        },
      ],
      breadcrumbs: [
        {
          text: this.$t('dashboard'),
          disabled: false,
          to: "/",
        },
        {
          text: this.$t('organizationNTR'),
          link: true,
          exact: true,
          disabled: false,
          to: { name: "ProductList" },
        },
        {
          text: this.$t('organizationNtrInfo.farmProducts'),
          disabled: true,
          href: "breadcrumbs_link_1",
        },
      ],
    };
  },
  watch: {
    tableOptions: {
      handler() {
        this.getItem();
      },
      deep: true,
    },
  },
  methods: {
    selectItem(item) {
      this.selectedItem = item;
    },
    unSelectItem() {
      this.selectedItem = false;
    },
    resetTableStructure() {
      this.startLoading();
      this.tableHeaders = this.headers.filter((header) =>
        this.selectedHeaders.includes(header.text)
      );
      this.tableOptions.itemsPerPage =
        this.itemsPerPageOptions[this.itemsPerPageSlider];
      this.menu = false;
      this.stopLoading();
    },
    searchUsers() {
      if (this.search === "") return;
      if (this.checkBreakPoints) {
        this.tabletTableOptions.page = 1;
        this.getTabletItem();
      } else {
        this.tableOptions.page = 1;
        this.getItem();
      }
    },
    resetSearchOnEmpty() {
      if (this.search === "") return;
      if (this.checkBreakPoints) {
        this.tabletTableOptions.page = 1;
        this.getTabletItem();
      } else {
        this.tableOptions.page = 1;
        this.getItem();
      }
    },
    async getItem() {
      // this.startLoading()
      this.loading = true;
      NtrService.getfarmProducts(
        this.tableOptions,
        this.search,
        this.$route.params.farmId
      )
        .then(async (res) => {
          this.items = res.data.products.rows;
          this.totalproducts = res.data.products.total_rows;

          if (this.totalproducts < 1) {
            this.oldSelected = this.selectedHeaders;
            this.selectedHeaders = this.noRecordHeader;
          } else {
            if (this.oldSelected.length > 1)
              this.selectedHeaders = this.oldSelected;
            else {
              this.selectedHeaders = this.allSelectedHeaders;
              this.oldSelected = [];
            }
          }
          this.resetTableStructure();
          this.currentrows = res.data.products.num_rows;
          this.pageCount = Math.ceil(
            this.totalproducts / this.tableOptions.itemsPerPage
          );
          this.totalPages = Math.ceil(
            this.totalproducts / this.tableOptions.itemsPerPage
          );
          this.from =
            (this.tableOptions.page - 1) * this.tableOptions.itemsPerPage + 1;
          this.to =
            this.tableOptions.page * this.tableOptions.itemsPerPage -
            (this.tableOptions.itemsPerPage - res.data.products.num_rows);
          // this.stopLoading()
          this.loading = false;
        })
        .catch((err) => {
          console.log(err);
          // this.stopLoading()
          this.loading = false;
        });
    },
    async getTabletItem() {
      // this.startLoading()
      NtrService.getfarmProducts(
        this.tabletTableOptions,
        this.search,
        this.$route.params.farmId
      )
        .then(async (res) => {
          this.items = res.data.products.rows;
          this.currentrows = res.data.products.num_rows;
          this.totalproducts = res.data.products.total_rows;
          this.pageCount = Math.ceil(
            this.totalproducts / this.tabletTableOptions.itemsPerPage
          );
          this.totalPages = Math.ceil(
            this.totalproducts / this.tabletTableOptions.itemsPerPage
          );
          this.from =
            (this.tabletTableOptions.page - 1) *
              this.tabletTableOptions.itemsPerPage +
            1;
          this.to =
            this.tabletTableOptions.page *
              this.tabletTableOptions.itemsPerPage -
            (this.tabletTableOptions.itemsPerPage - res.data.products.num_rows);
          // this.stopLoading()
        })
        .catch((err) => {
          console.log(err);
          // this.stopLoading()
        });
    },
    pageChange(t) {
      if (t) this.tableOptions.page = this.tableOptions.page + 1;
      else this.tableOptions.page = this.tableOptions.page - 1;

      this.getItem();
    },
    tabletPageChange(t) {
      if (t) this.tabletTableOptions.page = this.tabletTableOptions.page + 1;
      else this.tabletTableOptions.page = this.tabletTableOptions.page - 1;

      this.getTabletItem();
    },
    async exportToPDF() {
      html2pdf(this.$refs.document, {
        margin: 1,
        filename: "farmProducts.pdf",
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: { dpi: 200, letterRendering: true },
        jsPDF: {
          unit: "in",
          format: "letter",
          orientation: "landscape",
          compress: false,
        },
      });
    },

    async printPDF() {
      let opt = {
        margin: 1,
        filename: "farmProducts.pdf",
        image: { type: "jpeg", quality: 0.95 },
        html2canvas: { scale: 2, useCORS: true },
        jsPDF: { unit: "in", format: "a4", orientation: "landscape" },
      };

      let worker = await html2pdf()
        .set(opt)
        .from(this.$refs.document)
        .toCanvas()
        .outputPdf("blob", "farmProducts.pdf");
      let file = new File([worker], "SingleProducts.pdf", {
        type: "application/pdf",
      });
      console.log(file);
      var pdfUrl = await URL.createObjectURL(file);
      console.log(pdfUrl);
      await printJS({ printable: `${pdfUrl}`, type: "pdf", showModal: true });
    },

    goToNextFarm(){
      this.farmCounter++;
      let farmNumber = this.farms[this.farmCounter];
      // let index = this.farms.indexOf(farmNumber)
      if(this.farms.length < this.farmCounter+1 ){
        // disable link
        return;
      }

      this.$router.push({
        name: 'FarmProducts',
        params: { farmId: farmNumber },
      })
      // this.$route.params.farmId = farmNumber;
      this.getItem();
    }
  },
  mixins: [loadingMixin],
};
</script>
<style lang="scss" scoped>
::v-deep .v-data-table-header {
  background: $secondary2-color;
}
::v-deep .v-data-table-header span {
  // text-transform: uppercase !important;
  color: black;
}
tbody tr:nth-of-type(odd) {
  background-color: rgba(0, 0, 0, 0.035);
}
</style>
